import { DefaultEnvConnectionErrorPage } from './DefaultEnvConnectionErrorPage';
import { SweepError } from '@server/sweep-errors';
import { EnvConnectionError } from './envConnectionErrorTypes';
import { SfEnvConnectionErrorPage } from './SfEnvConnectionErrorPage';
import { RequestLimitEnvConnectionErrorPage } from './RequestLimitEnvConnectionErrorPage';

export const EnvConnectionErrorPage = ({
  envConnectionError,
  allowDeleteLastEnv,
}: {
  envConnectionError: EnvConnectionError;
  allowDeleteLastEnv: boolean;
}) => {
  const { error } = envConnectionError;

  if (error === SweepError.CrmOrgBadCredentials) {
    return (
      <SfEnvConnectionErrorPage
        envConnectionError={envConnectionError}
        allowDeleteLastEnv={allowDeleteLastEnv}
      />
    );
  }
  if (
    [
      SweepError.RequestLimitExceededTotalRequests,
      SweepError.RequestLimitExceededConcurrentRequests,
    ].includes(error)
  ) {
    return <RequestLimitEnvConnectionErrorPage />;
  }

  return <DefaultEnvConnectionErrorPage />;
};
